import { render } from "./AboutUs.vue?vue&type=template&id=0994dc85&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=0994dc85&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0994dc85"

export default script